<template>
<div class="main-div">
    <h3 class="auth-title">
        🎉 Seu teste gratuito já começou!
    </h3>
    <p style="color: lightslategray; margin-bottom: 2em;">
        📲 Precisa de ajuda para começar? Enviamos no seu WhatsApp um tutorial prático para aproveitar tudo da plataforma.
    </p>
    <button class="btn btn-yup-purple btn-login" @click="$router.push('/login')" :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending">
        👉 Acessar a plataforma agora
    </button>
</div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Obrigado',
  data() {
    return {
      isSending: false,
      terms: false,
      form: {
        fullname: '',
        company: '',
        agents: 1,
        email: '',
        mobile_number: '',
        password: '',
      },
    };
  },
};
</script>

  <style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  .social-group {
    gap: 16px;
  }

  .main-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15vh;
  }

  .auth-title {
    font-size: 30px;
    margin-bottom: 1em;

    .btn {
      padding: 0;
      font-size: 24px;
    }
  }

  .btn-login {
        margin: 0 auto;
        width: 300px;
        height: 60px;
        font-weight: 500;
        font-size: 1em;
    }

  ::v-deep .form-group {
    label {
      color: #752DE6 !important;
      margin-bottom: 0.32rem!important;
      font-size: .785rem !important;
    }
  }

  ::v-deep .form-group {
    label {
      span {
        display: none;
      }
    }
  }

  ::v-deep .form-group {
    .form-control {
      border: 2px solid rgba(117, 45, 230, 0.16);
      padding: 10px 15px !important;
    }

    input[type="tel"] {
      border-right: 2px solid rgba(117, 45, 230, 0.16)!important;
      border-radius: 0px 10px 10px 0px!important;
    }

    .material-icons-outlined {
      color: gainsboro!important;
    }

    .v-select {
      .vs__dropdown-toggle {
        border-color: rgba(117, 45, 230, 0.16);
      }
    }
  }

  ::v-deep .primary {
    height: 53px !important;
    font-weight: 600 !important;
  }

  ::v-deep .btn-icon {
    border: 1px 1px 1px 0px;
    border-color: rgba(117, 45, 230, 0.16) !important;
  }

  ::v-deep .dropdown-toggle {
    border: 1px 1px 1px 0px;
    border-color: rgba(117, 45, 230, 0.16) !important;
  }

  ::v-deep .form-group {
    .v-select {
      .vs__dropdown-toggle {
        input {
          font-size: 14.3px!important;
          color: #C6CDDE!important;
        }
      }
    }
  }

  ::v-deep .separator::before,
  ::v-deep .separator::after {
    border-top: 2px solid rgba(117, 45, 230, 0.16) !important;
  }

  ::v-deep .separator {
    span {
          margin: 0px 10px;
          font-size: 15px;
    }
  }

  ::v-deep .google-btn {
    width: 202px;
    border: 2px solid rgba(117, 45, 230, 0.16) !important;
    margin-bottom: 0px!important;
    &:hover {
      background-color: rgba(117, 45, 230, 0.16) !important;
    }
  }

  ::v-deep .facebook-btn {
    width: 202px;
    border: 2px solid rgba(117, 45, 230, 0.16) !important;
    margin-bottom: 0px!important;
    &:hover {
      background-color: rgba(117, 45, 230, 0.16) !important;
    }
    background-color: white!important;
    i {
      color: #1877F2!important;
    }
  }

  h3, p {
    text-align: center;
  }
  </style>
